import React from 'react';

import { Message } from 'src/core/components';
import messages from 'src/components/OligoDNA/messages';

export const nonDuplicateEmailValidator = (formState) => ({
  validator: (newValue) => {
    const hasDuplicateEmail = formState.find(
      (data) => data.value === newValue
    );

    return hasDuplicateEmail ? 'error' : 'success';
  },
  errorMessage: <Message message={messages.emailAlreadyMentioned} />
});
